import box from './box'
import breakpoints from './breakpoints'
import {
  buildYourDreamBagButtons,
  greatestHitsButtons,
  stwButtons,
  ultimateCoachingTripButtons,
} from './buttons'
import {
  buildYourDreamBagColors,
  greatestHitsColors,
  ultimateCoachingTripColors,
} from './colors'
import fonts from './fonts'
import fontWeights from './fontWeights'
import {
  buildYourDreamBagForms,
  greatestHitsForms,
  stwForms,
  ultimateCoachingTripForms,
} from './forms'
import grids from './grids'
import icons from './icons'
import images from './images'
import input from './input'
import label from './label'
import layout from './layout'
import links from './links'
import select from './select'
import sizes from './size'
import sliders from './sliders'
import styles from './styles'
import {
  buildYourDreamBagText,
  greatesHitsText,
  ultimateCoachingTripText,
} from './text'

const baseTheme = {
  fonts,
  fontWeights,
  input,
  links,
  images,
  sizes,
  layout,
  label,
  box,
  grids,
  icons,
  sliders,
  styles,
  select,
  breakpoints,
}

export const buildYourDreamBagTheme = {
  ...baseTheme,
  buttons: buildYourDreamBagButtons,
  colors: buildYourDreamBagColors,
  forms: buildYourDreamBagForms,
  text: buildYourDreamBagText,
}

export const greatestHitsTheme = {
  ...baseTheme,
  buttons: greatestHitsButtons,
  colors: greatestHitsColors,
  forms: greatestHitsForms,
  text: greatesHitsText,
}

export const ultimateCoachingTripTheme = {
  ...baseTheme,
  buttons: ultimateCoachingTripButtons,
  colors: ultimateCoachingTripColors,
  forms: ultimateCoachingTripForms,
  text: ultimateCoachingTripText,
}

export const spintToWinTheme = {
  ...baseTheme,
  buttons: stwButtons,
  forms: stwForms,
}
